import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/admin", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sid })
      .then((r) => {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: r.data }, replace: true });
      })
      .catch(() => navigate("/admin", { replace: true }));
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center" data-testid="auth-callback">
      <p className="font-ui text-paper/50 text-xs uppercase tracking-[0.3em]">Signing you in…</p>
    </div>
  );
}
